import React from 'react';

export const ContentIcon = ({ isGroup, cgroupId }) => (
  <i
    className={
      !isGroup
        ? 'fa fa-file'
        : cgroupId === null
        ? 'fa fa-folder'
        : 'fa fa-folder-o'
    }
  />
);
